/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.TechSphere {
    angular.module("meevo.plugins.techSphere", []);
}